let dbPromise: Promise<IDBDatabase> | null = null;

const openDatabase = () => {
	if (!dbPromise) {
		dbPromise = new Promise<IDBDatabase>((resolve, reject) => {
			const request = indexedDB.open('joi-cache', 1);

			request.onupgradeneeded = () => {
				const db = request.result;
				if (!db.objectStoreNames.contains('cache')) {
					db.createObjectStore('cache');
				}
			};

			request.onsuccess = () => {
				resolve(request.result);
			};

			request.onerror = () => {
				reject(request.error);
			};
		});
	}

	return dbPromise;
};

const putCache = async (key: string, value: unknown) => {
	const db = await openDatabase();
	const tx = db.transaction('cache', 'readwrite');
	const store = tx.objectStore('cache');
	store.put(value, key);

	return new Promise<void>((resolve, reject) => {
		tx.oncomplete = () => resolve();
		tx.onerror = () => reject(tx.error);
		tx.onabort = () => reject(tx.error);
	});
};

const getCache = async (key: string) => {
	const db = await openDatabase();
	const tx = db.transaction('cache', 'readonly');
	const store = tx.objectStore('cache');

	return new Promise<unknown>((resolve, reject) => {
		const request = store.get(key);
		request.onsuccess = () => resolve(request.result);
		request.onerror = () => reject(request.error);
	});
};

const deleteCache = async (key: string) => {
	const db = await openDatabase();
	const tx = db.transaction('cache', 'readwrite');
	const store = tx.objectStore('cache');
	store.delete(key);

	return new Promise<void>((resolve, reject) => {
		tx.oncomplete = () => resolve();
		tx.onerror = () => reject(tx.error);
		tx.onabort = () => reject(tx.error);
	});
};

const indexDb = { putCache, getCache, deleteCache };

export default indexDb;
